import { render } from "./GameDisgaea1.vue?vue&type=template&id=6fc3b100&scoped=true"
import script from "./GameDisgaea1.vue?vue&type=script&lang=js"
export * from "./GameDisgaea1.vue?vue&type=script&lang=js"

import "./GameDisgaea1.vue?vue&type=style&index=0&id=6fc3b100&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fc3b100"]])

export default __exports__